var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesInvoiceActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#FA6B85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5h-9a1 1 0 0 0-1 1v12.5a.5.5 0 0 0 .5.5h.5a.499.499 0 0 0 .4-.2L9 17.334l1.1 1.466a.518.518 0 0 0 .8 0l1.1-1.466 1.1 1.466a.518.518 0 0 0 .8 0l1.1-1.466 1.1 1.466a.5.5 0 0 0 .4.2h.5a.5.5 0 0 0 .5-.5V6a1.001 1.001 0 0 0-1-1zm0 12.666L15.4 16.2a.518.518 0 0 0-.8 0l-1.1 1.466-1.1-1.466a.518.518 0 0 0-.8 0l-1.1 1.466L9.4 16.2a.518.518 0 0 0-.8 0l-1.1 1.466V6h9v11.666z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.553 12.251c0 .38-.094.709-.282.984a1.746 1.746 0 0 1-.8.633c-.345.147-.758.22-1.239.22-.234 0-.458-.013-.672-.04a4.63 4.63 0 0 1-.606-.114 3.294 3.294 0 0 1-.514-.189v-.993c.26.114.552.218.874.312.322.09.65.136.984.136.273 0 .498-.035.677-.105a.849.849 0 0 0 .404-.308.841.841 0 0 0 .132-.47.763.763 0 0 0-.154-.483 1.397 1.397 0 0 0-.465-.36 7.81 7.81 0 0 0-.774-.357 5.254 5.254 0 0 1-.606-.29 2.463 2.463 0 0 1-.51-.382 1.65 1.65 0 0 1-.356-.519 1.827 1.827 0 0 1-.127-.712c0-.363.086-.673.259-.931.176-.258.422-.456.738-.594a2.8 2.8 0 0 1 1.116-.206c.337 0 .654.035.95.105.298.07.591.17.878.3l-.334.847a5.947 5.947 0 0 0-.769-.259 2.97 2.97 0 0 0-.755-.097c-.223 0-.412.034-.567.101a.793.793 0 0 0-.356.286.765.765 0 0 0-.119.43c0 .188.045.346.136.475.094.126.238.242.431.348.196.105.448.222.756.351.354.147.655.3.9.462.25.16.44.354.572.58.132.222.198.502.198.839z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesInvoiceActiveIcon);
export default __webpack_public_path__ + "static/media/salesInvoiceActiveIcon.25217da9484609fda7104860359f850e.svg";
export { ForwardRef as ReactComponent };